<script>
import Layout from "../layouts/auth";
import {
  numeric,
  required,
  email,
  maxLength,
  requiredIf,
} from "vuelidate/lib/validators";
import VueCountryCode from "vue-country-code";
import { mapActions, mapGetters } from "vuex";
import axios from "axios";

export default {
  page: {
    title: "QuickPass",
  },
  components: {
    Layout,
    VueCountryCode,
  },
  data() {
    return {
      email_req_style: true,
      form: {
        first_name: null,
        last_name: null,
        email: null,
        phone: null,
        register_check: false,
      },
      submitted: false,
      email_typing: false,
      phoneInputTyping: false,
      // Debounce timers for checkDuplicated below - each watcher that
      // triggers a phone/email check clears the previous one before
      // scheduling its own, so typing a full value sends one request
      // instead of one per keystroke.
      phoneCheckTimer: null,
      emailCheckTimer: null,
      phone_input: null,
      userCountryCode: null,
    };
  },
  validations: {
    form: {
      first_name: {
        required,
        maxLength: maxLength(20),
      },
      last_name: {
        required,
        maxLength: maxLength(20),
      },
      email: {
        email,
        required: requiredIf(function () {
          const {
            form: { register_check },
            phone_input,
          } = this;
          return register_check && !phone_input;
        }),
      },
    },
    phone_input: {
      required: requiredIf(function () {
        const {
          form: { email, register_check },
        } = this;
        return register_check && !email;
      }),
      numeric,
      maxLength: maxLength(30),
    },
  },
  watch: {
    userCountryCode(user_country_code) {
      if (this.phone_input && this.phone_input.length > 0) {
        this.form.phone = `${user_country_code}${this.phone_input}`;
        if (this.form.register_check) {
          // enable api if the register check is true
          this.phoneInputTyping = true;
          clearTimeout(this.phoneCheckTimer);
          this.phoneCheckTimer = setTimeout(() => {
            this.checkDuplicated({
              field: "phone",
              value: `${user_country_code}${this.phone_input}`,
            });
          }, 500);
        }
      } else {
        this.form.phone = null;
      }
    },
    "form.register_check"(register_check) {
      if (register_check && this.form.phone) {
        this.phoneInputTyping = true;
        clearTimeout(this.phoneCheckTimer);
        this.phoneCheckTimer = setTimeout(() => {
          this.checkDuplicated({
            field: "phone",
            value: this.form.phone,
          });
        }, 500);
      }
      if (register_check && this.form.email) {
        this.email_typing = true;
        clearTimeout(this.emailCheckTimer);
        this.emailCheckTimer = setTimeout(() => {
          this.checkDuplicated({
            field: "email",
            value: this.form.email,
          });
        }, 500);
      }
    },
    phone_input(phone_input) {
      if (phone_input && phone_input.length > 0) {
        this.form.phone = `${this.userCountryCode}${phone_input}`;
        if (this.form.register_check) {
          // enable api if the register check is true
          this.phoneInputTyping = true;
          clearTimeout(this.phoneCheckTimer);
          this.phoneCheckTimer = setTimeout(() => {
            this.checkDuplicated({
              field: "phone",
              value: `${this.userCountryCode}${phone_input}`,
            });
          }, 500);
        }
      } else {
        this.form.phone = null;
      }
    },
    "form.email"(email) {
      if (email && email.length > 0 && this.form.register_check) {
        this.email_typing = true;
        clearTimeout(this.emailCheckTimer);
        this.emailCheckTimer = setTimeout(() => {
          this.checkDuplicated({
            field: "email",
            value: email,
          });
        }, 500);
      }
    },
    getQrUrl(val) {
      if (val !== null) {
        this.$store.commit("quickpass/setLoading", true);
        this.$store.commit("quickpass/setSubmitted", true);
        setTimeout(() => {
          document.getElementById("qr_container").classList.remove("d-none");
          this.$store.commit("quickpass/setLoading", false);
          this.$store.commit("quickpass/setSubmitted", false);
        }, 1800);
      }
    },
  },
  computed: {
    ...mapGetters("quickpass", [
      "getLoading",
      "getSubmitted",
      "getQrUrl",
      "getPdfUrl",
    ]),
    ...mapGetters("authfack", [
      "getPhoneDuplicatedCheck",
      "getEmailDuplicatedCheck",
      "getLoadingSubmitStatus",
    ]),
    disableSubmitBtn() {
      const {
        form: { first_name, last_name, email, phone, register_check },
        getEmailDuplicatedCheck,
        getPhoneDuplicatedCheck,
      } = this;
      const checkEmailValidation =
        email && getEmailDuplicatedCheck && getEmailDuplicatedCheck.available;
      const checkPhoneValidation =
        phone && getPhoneDuplicatedCheck && getPhoneDuplicatedCheck.available;
      return register_check
        ? !(
            first_name &&
            last_name &&
            (checkEmailValidation || checkPhoneValidation)
          )
        : !(first_name && last_name);
    },
    hasAnyValidationErr() {
      return (this.form.email &&
      this.getEmailDuplicatedCheck &&
      !this.getEmailDuplicatedCheck.available
        ? true
        : false) ||
        (this.form.phone &&
          this.getPhoneDuplicatedCheck &&
          !this.getPhoneDuplicatedCheck.available)
        ? true
        : false;
    },
  },
  methods: {
    ...mapActions("quickpass", ["generateQr", "resetState"]),
    ...mapActions("authfack", ["checkDuplicated", "passportRegisteration"]),
    onSubmit() {
      const {
        form: { register_check },
        form,
        passportRegisteration,
        getQrUrl,
        createQuickPass,
        downloadQuickPass,
        getEmailDuplicatedCheck,
        getPhoneDuplicatedCheck,
      } = this;
      this.submitted = true;
      const checkEmailValidation =
        getEmailDuplicatedCheck && getEmailDuplicatedCheck.available;
      const checkPhoneValidation =
        getPhoneDuplicatedCheck && getPhoneDuplicatedCheck.available;
      this.$v.form.$touch();
      if (register_check) {
        this.email_typing = true;
        this.phoneInputTyping = true;
        !this.$v.$anyError &&
          (checkEmailValidation || checkPhoneValidation) &&
          passportRegisteration(form);
      } else {
        !this.$v.$anyError &&
          (!getQrUrl ? createQuickPass() : downloadQuickPass());
      }
    },
    createQuickPass() {
      this.$store.commit("quickpass/setSubmitted", true);
      this.$v.form.$touch();
      if (!this.$v.form.$invalid) {
        this.generateQr(this.form);
      }
    },
    forceFileDownload(response) {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", this.getPdfUrl); //or any other extension
      document.body.appendChild(link);
      link.click();
    },
    downloadQuickPass() {
      axios({
        method: "get",
        url: this.getPdfUrl,
        responseType: "arraybuffer",
      })
        .then((response) => {
          this.forceFileDownload(response);
        })
        .catch(() => console.log("error occurred"));
    },
    onPhoneInputTyping() {
      this.phoneInputTyping = true;
    },
    onEmailTyping() {
      this.email_typing = true;
    },
    onSelectUserCountryCode({ dialCode }) {
      this.userCountryCode = dialCode;
      console.log(`dialCode: ${dialCode}`);
    },
  },
  beforeMount() {
    this.resetState();
  },
};
</script>

<template>
  <Layout>
    <div class="quick-pass-wrapper">
      <div class="quick-pass-form">
        <div class="header register-header" v-if="form.register_check">
          <div class="logo-wrapper">
            <img src="@/assets/images/logo-lg.svg"
            width="86px"
              height="16px"
            class="unselectable" alt />
          </div>
          <p class="register-form-title">{{ $t('common.passportAcc').toUpperCase()}}</p>
          <p class="register-sub-title">{{ $t('common.register')}}</p>
        </div>
        <div class="header" v-else>
          <div class="logo-wrapper">
            <img src="@/assets/images/logo-lg.svg"
            width="86px"
              height="16px"
            class="unselectable" alt />
          </div>
          <p class="form-title">
            {{ $t('auth.generateQuickpass')}}
          </p>
          <p class="sub-title">
            {{ $t('auth.dataStore')}}
          </p>
        </div>
        <div class="content">
          <b-form @submit.prevent="onSubmit" novalidate>
            <div class="row-group first-last-name-wrapper">
              <!-- first name  -->
              <div class="first-name">
                <div
                  class="form-group m-d-gruop"
                  :class="$v.form.first_name.$error && 'invalid-value'"
                >
                  <div class="required-star">
                    <span class="required">*</span>
                  </div>
                  <input
                    v-model="form.first_name"
                    type="text"
                    class="form-control"
                    :class="{'cursor-not-allowed':form.first_name && form.first_name.length >= 20}"
                    maxLength="20"
                    id="first_name"
                    required
                  />
                  <label for="first_name">{{ $t('common.firstName')}}</label>
                </div>
                <div class="err-wrapper">
                  <div v-if="submitted && !$v.form.first_name.required">
                    <span class="error-value">{{ $t('validation.requiredValidation',{value: $t('common.firstName')})}}</span>
                  </div>
                  <div v-if="submitted && !$v.form.first_name.maxLength">
                    <span class="error-value">{{$t('validation.maxLen',{value: 30})}}</span>
                  </div>
                </div>
              </div>
              <!-- last name  -->
              <div class="last-name">
                <div
                  class="form-group m-d-gruop"
                  :class="$v.form.last_name.$error && 'invalid-value'"
                >
                  <div class="required-star">
                    <span class="required">*</span>
                  </div>
                  <b-form-input
                    id="last_name"
                    v-model.trim="form.last_name"
                    :class="{'cursor-not-allowed':form.last_name && form.last_name.length >= 20}"
                    type="text"
                    required
                    maxLength="20"
                  />
                  <label for="last_name">{{ $t('common.lastName')}}</label>
                </div>
                <div class="err-wrapper">
                  <div v-if="submitted && !$v.form.last_name.required">
                    <span class="error-value">{{ $t('validation.requiredValidation',{value: $t('common.lastName')})}}</span>
                  </div>
                  <div v-if="submitted && !$v.form.last_name.maxLength">
                    <span class="error-value">{{$t('validation.maxLen',{value: 30})}}</span>
                  </div>
                </div>
              </div>
            </div>
            <!-- register email phone  -->
            <div class="register-email-phone">
              <div class="register-hint" v-show="form.register_check">
                <hr class="h-line" />
                <p class="hint-label">{{ $t('common.emailOrPhone')}}</p>
              </div>
              <!-- email   -->
              <div class="email-wrapper">
                <div
                  class="form-group m-d-gruop"
                  :class="$v.form.email.$error && 'invalid-value'"
                >
                  <b-form-input
                    id="email"
                    v-model.trim="form.email"
                    type="text"
                    :required="
                      email_req_style ||
                      (form.register_check && form.phone == null)
                    "
                    class="form-control"
                    @input="$v.form.email.$touch()"
                    @keypress="onEmailTyping"
                    @paste="onEmailTyping"
                  />
                  <label for="email">{{ $t('common.email')}}</label>
                </div>
                <div class="err-wrapper">
                  <div v-if="email_typing && !$v.form.email.email">
                    <span class="error-value">{{ $t('validation.validEmail') }}</span>
                  </div>
                  <div
                    v-else-if="
                      email_typing &&
                      form.email &&
                      getEmailDuplicatedCheck &&
                      !getEmailDuplicatedCheck.available &&
                      getEmailDuplicatedCheck.msg.length == 0 &&
                      form.register_check
                    "
                  >
                    <span class="error-value"
                      >{{ $t('form.emailAlreadyExists') }} or
                      <router-link tag="a" to="/login" class="redirect-login"
                        >{{ $t('common.login').toUpperCase() }}</router-link
                      ></span
                    >
                  </div>
                  <div
                    v-else-if="
                      email_typing &&
                      form.email &&
                      getEmailDuplicatedCheck &&
                      getEmailDuplicatedCheck.msg.length > 0
                    "
                  >
                    <span class="error-value" v-show="form.register_check"
                      >{{ $t('validation.deactivatedAccEmail') }}
                      <router-link tag="a" to="/login" class="redirect-login"
                        >{{ $t('common.login').toUpperCase() }}</router-link
                      ></span
                    >
                  </div>
                </div>
              </div>

              <!-- phone  -->
              <div class="input-wrapper current-phone">
                <div class="row-group phone-group justify-content-start">
                  <VueCountryCode
                    class="country-code-input"
                    :disabledFetchingCountry="true"
                    @onSelect="onSelectUserCountryCode"
                    :enabledCountryCode="true"
                    :preferredCountries="['GB', 'US', 'CN']"
                  />
                  <div class="form-group m-d-gruop w-100 mb-0">
                    <b-form-input
                      id="phone"
                      v-model.trim="phone_input"
                      type="number"
                      :required="
                        email_req_style ||
                        (form.register_check && form.email == null)
                      "
                      maxLength="30"
                      @input="$v.phone_input.$touch()"
                      @keypress="onPhoneInputTyping"
                    />
                    <label for="phone">{{ $t('common.phoneNumber')}}</label>
                  </div>
                </div>
                <div class="err-wrapper">
                  <div v-if="(phoneInputTyping && !$v.phone_input.required) || (email_typing && !$v.form.email.required)">
                    <span class="error-value"
                      >{{ $t('validation.requiredValidation',{value: $t('common.phoneOrEmail')})}}</span
                    >
                  </div>
                  <div
                    v-else-if="
                      phoneInputTyping &&
                      phone_input &&
                      getPhoneDuplicatedCheck &&
                      !getPhoneDuplicatedCheck.available &&
                      getPhoneDuplicatedCheck.msg.length == 0
                    "
                  >
                    <span class="error-value" v-if="form.register_check"
                      >{{ $t('form.phoneAlreadyExists') }} or
                      <router-link tag="a" to="/login" class="redirect-login"
                        >{{ $t('common.login').toUpperCase()}}</router-link
                      ></span
                    >
                  </div>
                  <div
                    v-else-if="
                      phoneInputTyping &&
                      phone_input &&
                      getPhoneDuplicatedCheck &&
                      getPhoneDuplicatedCheck.msg.length > 0
                    "
                  >
                    <span class="error-value"
                      >{{ $t('validation.deactivatedAccPhone')}}
                      <router-link tag="a" to="/login" class="redirect-login"
                        >{{ $t('common.login').toUpperCase()}}</router-link
                      ></span
                    >
                  </div>
                  <div v-else-if="submitted && !$v.phone_input.numeric">
                    <span class="error-value">
                      {{ $t('validation.phoneDigitsOnly') }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <!-- quick pass email phone  -->
            <div class="passport-email-phone">
            </div>
            <!-- qr code  -->
            <div class="row mt-4 mb-2" v-if="this.getQrUrl">
              <div class="col-xs-12 text-center d-none" id="qr_container">
                <img :src="this.getQrUrl" class="qr_image" />
              </div>
            </div>
            <!-- register account check  -->
            <div
              v-if="!this.getQrUrl"
              class="register-account-check-wrapper register-checkbox"
            >
              <b-form-checkbox
                class="custom-checkbox-dark custom-checkbox"
                v-model="form.register_check"
              >
              </b-form-checkbox>
              <p class="text">
                {{ $t('auth.registerValidQR')}}
              </p>
            </div>
            <div class="d-flex justify-content-center">
              <!-- submit btn  -->
              <b-button
                variant="primary"
                type="submit"
                class="submit-btn btn-block text-center mt-3 submit-button"
                :disabled="
                  disableSubmitBtn ||
                  getLoading ||
                  getLoadingSubmitStatus ||
                  (form.register_check && hasAnyValidationErr) ||
                  $v.$anyError
                "
              >
                <span>
                  <i
                    v-if="getLoading || getLoadingSubmitStatus"
                    class="bx bx-loader bx-spin font-size-16 align-middle mr-2"
                  ></i>
                  {{
                    form.register_check
                      ? $t('common.register')
                      : this.getQrUrl == null
                      ? $t('common.generate')
                      : $t('common.downloadQuickpass')
                  }}
                </span>
              </b-button>
            </div>
          </b-form>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style lang="scss" scoped>
.cursor-not-allowed{
  cursor: not-allowed;
}
.quick-pass-wrapper {
  padding: 50px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  .quick-pass-form {
    text-align: center;
    padding: 73px 41px 41px 41px;
    background-color: #fff;
    width: 490px;
    border-radius: 14px;
    .header {
      margin-bottom: 33px;
      .logo-wrapper {
        margin-bottom: 30px;
        img {
          width: 30%;
        }
      }
      .register-form-title {
        font-weight: bold;
        font-size: 20px;
        line-height: 24px;
        text-align: center;
        color: #000000;
      }
      .register-sub-title {
        font-weight: bold;
        font-size: 16px;
        line-height: 19px;
        text-align: center;
        color: rgba(0, 0, 0, 0.28);
      }
      .form-title {
        font-weight: 700;
        font-size: 14px;
        line-height: 20px;
        letter-spacing: 0.25px;
        color: #000000;
        margin-bottom: 9px;
        padding: 0 35px;
      }
      .sub-title {
        padding: 0 5px;
        margin-bottom: 0;
        font-weight: normal;
        font-size: 13px;
        line-height: 20px;
        text-align: center;
        letter-spacing: 0.25px;
        color: #666666;
      }
    }
    .register-hint {
      margin-bottom: 16px;
      .h-line {
        margin-top: 0;
        margin-bottom: 14px;
      }
      .hint-label {
        font-weight: normal;
        font-size: 14px;
        line-height: 20px;
        text-align: left;
        letter-spacing: 0.25px;
        color: rgba(0, 0, 0, 0.6);
        margin-bottom: 0;
        padding-left: 20px;
      }
    }
    .current-phone {
      margin-bottom: 36px;
    }
    .register-account-check-wrapper {
      padding: 0 23px;
      display: flex;
      align-items: flex-start;
      margin-bottom: 123px;

      .text {
        margin-bottom: 0;
        margin-left: 4px;
        text-align: left;
        font-size: 13px;
        color: #666666;
        font-weight: 400;
        //width: 233px;

      }
    }
    @media (max-width: 768px) {
      border-radius: 0px;
      .header {
        .logo{
          margin-bottom:23px ;
          margin-right: auto;
          margin-left: auto;
          width:116px!important;
        height: 22px!important;
         img{
        width:116px!important;
        height: 22px!important;
      }
    }
        .register-form-title {
          font-size: 16px;
        }
        .register-sub-title {
          font-size: 14px;
        }
      }
      .first-last-name-wrapper {
        display: block;
      }
      .register-hint {
        .hint-label {
          font-size: 12px;
        }
      }
      .register-account-check-wrapper {
        margin-bottom: 110px;
        .text {
          font-size: 13px;
        }
      }
    }
  }

  .required-star {
    position: relative;
    .required {
      color: #e51414;
      position: absolute;
      right: 10px;
      top: 18px;
      z-index: 1000;
      font-size: 1.2rem;
    }
  }
  .qr_image {
    width: 50%;
    border: 5px solid #000;
    border-radius: 15px;
    padding: 15px;
  }
  .err-margin {
    margin-bottom: 30px;
  }
  .invalid-feedback {
    margin-top: 0;
  }
  .row-group {
    display: flex;
    justify-content: space-between;
    .col-50 {
      width: 100%;
    }
    .col-50:first-of-type {
      margin-right: 0.7rem;
    }
  }
  .phone-err-wrapper {
    display: flex;
    justify-content: flex-start;
  }
  .name-row {
    margin-bottom: 30px;
  }
}
</style>
